<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        Create Contact Request
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" (click)="close()">
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
    <form [formGroup]="createContractRequestForm" autocomplete="off" novalidate>
        <div>
            <span class="label-text">Enter special requests <span class="under-label">(required, max 800 characters)</span></span>
            <textarea #note required rows="6" class="special-request-textarea" formControlName="notes" (keyup)="onKeyUp(note)"></textarea>
        </div>
        <div class="char-count">
            <span [ngClass]="{'red-text' : hasError('notes', 'maxlength')}">Characters Remaining: {{ charCount }}</span>
        </div>

        <mat-dialog-actions class="nova__dialog__content__actions" align="end">
            <button mat-raised-button color="primary" [disabled]="!createContractRequestForm.valid" (click)="send()">SEND</button>
            <button class="cancel-button" mat-button (click)="close()">CLOSE</button>
        </mat-dialog-actions>
    </form>
</div>
